import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ps-split-button',
  standalone: true,
  template: `<div
    class="d-flex"
    [attr.data-cy]="dataCy()"
    [attr.aria-label]="ariaLabel()"
  >
    <div class="ps-split-button action">
      <ng-content select="[psAction]"></ng-content>
    </div>
    <div class="ps-split-button dropdown">
      <ng-content select="[psDropdown]"></ng-content>
    </div>
  </div>`,
  styleUrl: './split-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplitButtonComponent {
  public readonly dataCy = input.required<string>();
  public readonly ariaLabel = input<string>('Split button');
}
